import PropTypes from 'prop-types';
import { useMemo } from 'react';
// material
import { CssBaseline } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
//
import { useLocalization } from '../contexts/localizationContext';
import { hrHR as muiHR } from '@mui/material/locale';
// eslint-disable-next-line no-unused-vars
import constants from '../constants';

// ----------------------------------------------------------------------

ThemeConfig.propTypes = {
  children: PropTypes.node
};
export default function ThemeConfig({ children }) {
  const localization = useLocalization();

  const theme = useMemo(
    () => {
      if (localization.locale === constants.locales.hrHR) {
        return createTheme({}, muiHR);

      }
      return createTheme({});
    },
    [localization.locale]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
